import { EditWorkoutVM } from '../view-models/workoutEdit.viewModel';
import _ from 'lodash';
import { Running } from './templates/Running';
import { LongVideo } from './templates/Video';
import { Circuit } from './templates/Circuit';
import { Exercise } from './templates/Exercise';
import { ArrayItem } from '@client/new/helpers/types';
import {
  LegacyExercise as ExerciseType,
  Video,
  Running as RunningType,
  RunningExerciseType,
} from '../models/workout.domain';
import { Workout } from '../../workout-editor/view/components/Workout';
import { CircuitTemplate } from '../view-models/mappers';
import {
  CollapsibleWorkoutHeader,
  HeaderContent,
} from '../../workout-editor/view/components/common/WorkoutHeader';
import { WorkoutItemMenu } from '../components/WorkoutItemMenu';

export const WorkoutTemplates = (p: EditWorkoutVM) => {
  return (
    <div className="flex flex-col gap-4">
      {p.exerciseTemplates.map((t, i) => {
        const header = {
          ...t.header,
          title: p.titlesMap[t.value.id || ''] || t.header.title,
        };

        return (
          <TemplateMapper
            {...t}
            header={header}
            influencerId={p.influencerId}
            key={t.value.uuid}
            dispatch={p.dispatch}
            index={i}
            control={p.control}
            submitting={p.submitting}
            workoutType={p.workoutType}
            inputHints={p.inputHints}
            readonly={p.readonly}
            expand={p.expandExercises.includes(i)}
            exerciseSuggestions={p.exerciseSuggestions}
          />
        );
      })}
    </div>
  );
};

type TemplateMapperProps = { index: number; expand: boolean } & Pick<
  EditWorkoutVM,
  | 'influencerId'
  | 'dispatch'
  | 'control'
  | 'submitting'
  | 'workoutType'
  | 'inputHints'
  | 'readonly'
  | 'exerciseSuggestions'
> &
  ArrayItem<EditWorkoutVM['exerciseTemplates']>;

const TemplateMapper = (p: TemplateMapperProps) => {
  switch (p.type) {
    case 'video':
      return (
        <LongVideo
          {...(p.value as Video)}
          header={p.header}
          menuItems={p.menuItems}
          influencerId={p.influencerId}
          dispatch={p.dispatch}
          index={p.index}
          control={p.control}
          submitting={p.submitting}
          workoutType={p.workoutType}
          inputHints={p.inputHints}
          readonly={p.readonly}
          exerciseSuggestions={p.exerciseSuggestions}
          expand={p.expand}
        />
      );
    case 'HIIT':
    case 'Tabata':
      return (
        <div>
          <CollapsibleWorkoutHeader
            Action={
              <WorkoutItemMenu
                items={p.menuItems}
                isCircuit={false}
                readonly={p.readonly}
              />
            }
            Header={
              <HeaderContent title={p.header.title} dotContent={p.type} />
            }
            defaultOpen
            // icon={p.header?.icon}
          >
            <div style={{ background: 'white' }}>
              <Workout exerciseIds={[p.value.id || '']} />
            </div>
          </CollapsibleWorkoutHeader>
        </div>
      );

    case 'exercise':
      return (
        <Exercise
          {...(p.value as ExerciseType)}
          header={p.header}
          menuItems={p.menuItems}
          influencerId={p.influencerId}
          dispatch={p.dispatch}
          index={p.index}
          control={p.control}
          submitting={p.submitting}
          circuitIndex={undefined}
          inputHints={p.inputHints}
          readonly={p.readonly}
          expand={p.expand}
          exerciseSuggestions={p.exerciseSuggestions}
        />
      );
    case 'circuit':
      return (
        <Circuit
          {...(p.value as CircuitTemplate)}
          header={p.header}
          menuItems={p.menuItems}
          influencerId={p.influencerId}
          dispatch={p.dispatch}
          index={p.index}
          control={p.control}
          submitting={p.submitting}
          inputHints={p.inputHints}
          readonly={p.readonly}
          exerciseSuggestions={p.exerciseSuggestions}
          expand={p.expand}
        />
      );
    case 'running':
      return (
        <Running
          {...(p.value as
            | RunningType<RunningExerciseType.Outdoor>
            | RunningType<RunningExerciseType.Treadmill>)}
          header={p.header}
          menuItems={p.menuItems}
          influencerId={p.influencerId}
          dispatch={p.dispatch}
          index={p.index}
          control={p.control}
          submitting={p.submitting}
          readonly={p.readonly}
          expand={p.expand}
        />
      );
    default:
      return null;
  }
};
